import { Paper, Typography, Button } from "@mui/material"

export const ButtonMessage = ({ body, footer, action, timestamp, links = [] }) => {
  // Formatear el timestamp para mostrar solo la hora
  const formatTime = (timestamp) => {
    const date = new Date(timestamp);
    return date.toLocaleTimeString([], { 
      hour: "2-digit", 
      minute: "2-digit", 
      hour12: true 
    });
  };

  // Reemplazar URLs con enlaces
  const renderTextWithLinks = (text) => {
    if (!links || links.length === 0) return text

    let result = text
    links.forEach((link) => {
      result = result.replace(
        link.text,
        `<a href="${link.url}" style="color: #0078FF; text-decoration: none; font-weight: 500;">${link.text}</a>`,
      )
    })

    return <div dangerouslySetInnerHTML={{ __html: result }} />
  }

  return (
    <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: "8px" }}>
      <Paper
        elevation={0}
        style={{
          backgroundColor: "#d9fdd3",
          padding: "6px 8px 6px 9px",
          borderRadius: "7.5px 7.5px 0 7.5px",
          maxWidth: "80%",
          overflowWrap: "break-word",
          wordWrap: "break-word",
          wordBreak: "break-word",
          whiteSpace: "pre-wrap",
          boxShadow: "0 1px 0.5px rgba(11,20,26,0.13)",
        }}
      >
        <Typography variant="body1">{renderTextWithLinks(body)}</Typography>

        {footer && (
          <Typography
            variant="body2"
            style={{
              marginTop: "8px",
              color: "#667781",
              fontSize: "14px",
            }}
          >
            {renderTextWithLinks(footer.text)}
          </Typography>
        )}

      <Typography
        variant="caption"
        style={{
          display: "block",
          textAlign: "right",
          marginTop: "4px",
          color: "#8696a0",
          fontSize: "11px",
        }}
      >
        {timestamp ? formatTime(timestamp) : ""}
      </Typography>

        <div
          style={{
            display: "flex",
            gap: "8px",
            marginTop: "8px",
          }}
        >
          {action?.buttons?.map((button, index) => (
            <Button
              key={index}
              variant="outlined"
              style={{
                borderColor: "#008069",
                backgroundColor: "#d9fdd3",
                color: "#008069",
                textTransform: "none",
                borderRadius: "18px",
                padding: "6px 12px",
                justifyContent: "center",
                fontWeight: "500",
                fontSize: "14px",
                flex: 1,
                minWidth: 0,
                boxShadow: "none",
              }}
            >
              {button.reply?.title}
            </Button>
          ))}
        </div>

       
      </Paper>
    </div>
  )
}

export default ButtonMessage

